/** Builds a Spring-style Page<T> envelope matching the generated Page*Response models. */
export function buildPageResponse<T>(items: T[], page: number, size: number) {
  const start = page * size;
  const content = items.slice(start, start + size);
  const totalElements = items.length;
  const totalPages = Math.max(1, Math.ceil(totalElements / size));

  return {
    content,
    empty: content.length === 0,
    first: page === 0,
    last: page >= totalPages - 1,
    number: page,
    numberOfElements: content.length,
    size,
    totalElements,
    totalPages,
    pageable: {
      pageNumber: page,
      pageSize: size,
      offset: start,
      paged: true,
      unpaged: false
    },
    sort: []
  };
}

/** Reads ?page=&size= off a request's query params with sane defaults. */
export function readPageParams(params: URLSearchParams, defaultSize = 100): { page: number; size: number } {
  const page = Number.parseInt(params.get('page') ?? '0', 10);
  const size = Number.parseInt(params.get('size') ?? String(defaultSize), 10);
  return {
    page: Number.isFinite(page) && page >= 0 ? page : 0,
    size: Number.isFinite(size) && size > 0 ? size : defaultSize
  };
}
